import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useField } from 'formik';

const SupplementDescription = ({ uid }) => {
  const name = `Supplements.[${uid}].Description`;
  const [field, , helpers] = useField(name);
  const [localFieldValue, setLocalFieldValue] = useState(field?.value);

  const handleBlur = e => {
    if (field?.value === e.target.value) return;
    helpers.setValue(e.target.value);
  };

  const handleChange = ({ target }) => setLocalFieldValue(target.value);

  useEffect(() => {
    if (field?.value == null || field.value === localFieldValue) return;
    setLocalFieldValue(field.value);
  }, [field?.value]);

  return (
    <div className="form-group">
      <label className="form-label" htmlFor={name}>
        Description
      </label>
      <textarea
        className="form-control"
        id={name}
        name={name}
        onBlur={handleBlur}
        onChange={handleChange}
        value={localFieldValue ?? ''}
      />
    </div>
  );
};

SupplementDescription.propTypes = {
  uid: PropTypes.string,
};

export default SupplementDescription;
